const initialState = { 
    redux_loader:false,
    redux_loader_password:false,
    user_activities:'',
 };

export function profile(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE_LOADER_STATE':
            state.redux_loader = action.loader_state;
            return {
                ...state
            };
        case 'UPDATE_LOADER_STATE_PASSWORD':
            state.redux_loader_password = action.loader_state_password;
            return {
                ...state
            };
        case 'USER_ACTIVITIES':
            return {
                ...state,
                user_activities: action.user_activities
            };
        case 'USER_GRAPH_DATA':
            return {
                ...state,
                user_graph_data: action.user_graph_data
            };
        default:
            return state
    }
  }


  


  